

































import Vue from "vue"

export default Vue.extend({

	data() {
		return {
		}
	},

	props: {
		anchor: {
			type: String,
		},
		arrow: {
			type: Boolean
		},
		cat: {
			type: String
		},
		icon: {
			type: String
		},
		hide: {
			type: Boolean
		},
		text: {
			type: String
		},
		passed: {
			type: Boolean
		},
		zoom: {
			type: Number,
		}
	},

	computed: {
		cssClasses():string[] {
			return [
				this.hide ? "hide" : "",
				this.cat,
				this.anchor,
				this.arrow == true ? "arrow" : "",
				this.passed ? "passed" : "",
				this.zoom < 12.5 ? "far" : "",
			]
		}

	}
});
